export const SITE_AVATAR_IMAGE_CROP_DIALOG_TITLE_DESKTOP = 'site-avatar-image-crop-dialog.title-desktop';
export const SITE_AVATAR_IMAGE_CROP_DIALOG_TITLE_MOBILE = 'site-avatar-image-crop-dialog.title-mobile';
export const SITE_AVATAR_IMAGE_CROP_DIALOG_CANCEL_BUTTON_TEXT = 'site-avatar-image-crop-dialog.cancel-button-text';
export const SITE_AVATAR_IMAGE_CROP_DIALOG_SAVE_BUTTON_TEXT = 'site-avatar-image-crop-dialog.save-button-text';
